import { signInAuthorizationCodeWithToken } from '../services/api/auth'
import { redirectToUrl } from './location'

/**
 * Native (iOS/Android) post-authentication redirect strategy.
 *
 * Replays the OAuth authorization-code exchange via `POST /session` with the
 * minted access token, then redirects to the resulting callback URL
 * (`swile://oauth.ios/redirect?code=...` resp. `swile-login://...?code=...`)
 * that the native auth webview intercepts to close itself.
 *
 * `redirectTo` is forwarded VERBATIM (its nested OAuth `state` is never touched).
 *
 * Shared by `SignInIOSRoute` / `SignInAndroidRoute` (via `BaseSignInRoute`) and
 * the BR activation funnel (`BrActivationRoute`) — do NOT fork it. Param order
 * matches `signInAuthorizationCodeWithToken`; each caller adapts.
 */
export const nativeAuthRedirect = async (
  accessToken: string,
  redirectTo: string,
  authenticationCode?: string,
  secondaryFactor?: string,
): Promise<void> => {
  const url = await signInAuthorizationCodeWithToken(accessToken, redirectTo, authenticationCode, secondaryFactor)
  redirectToUrl(new URL(url.redirect_to, window.location.origin))
}
